module.exports = __webpack_public_path__ + "static/scale-model-of-allen-texas-71f6d0e763f103c1d814f462f9ea917f.png";